__turbopack_context__.v({
  "logoCell": "IndustryLogoStrip-module__9E6UyG__logoCell",
  "logoGrid": "IndustryLogoStrip-module__9E6UyG__logoGrid",
  "logoGridCompact": "IndustryLogoStrip-module__9E6UyG__logoGridCompact",
  "logoImage": "IndustryLogoStrip-module__9E6UyG__logoImage",
  "logoStrip": "IndustryLogoStrip-module__9E6UyG__logoStrip",
});
